/* assets/bulk-buttons.js
   Works on PDP + Quick Add modal (delegated listener)
*/
(function () {
  // click handler for ANY .bulk-add-to-cart-button (PDP or modal)
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.bulk-add-to-cart-button');
    if (!btn) return;

    // Prevent double-taps
    if (btn.dataset.loading === 'true') return;
    btn.dataset.loading = 'true';
    btn.setAttribute('aria-disabled', 'true');

    const qty = btn.getAttribute('data-quantity');
    const productsAttr = btn.getAttribute('data-products') || '';
    const productList = productsAttr
      .split(';')
      .map(s => s.trim())
      .filter(Boolean); // remove empties

    try {
      if (productList.length) {
        // Expecting VARIANT IDs here
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: productList.map(id => ({ id, quantity: 1 }))
          })
        }).then(r => r.json());

        await refreshCartDrawer();
        // Open the drawer if present
        document.querySelector('cart-drawer')?.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      } else {
        // Fallback path: set qty and click the normal ATC
        const qtyInput = document.getElementById('custom_product_quantity_input');
        if (qtyInput && qty) qtyInput.value = qty;
        document.querySelector('.product-form__submit')?.click();
      }
    } catch (err) {
      console.error('Bulk add failed', err);
    } finally {
      btn.dataset.loading = 'false';
      btn.removeAttribute('aria-disabled');
    }
  });

  async function refreshCartDrawer() {
    // Fetch /cart and swap the <cart-drawer> HTML
    const html = await fetch('/cart').then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');
    if (!newDrawer || !currentDrawer) return;
    currentDrawer.classList.remove('is-empty');
    currentDrawer.innerHTML = newDrawer.innerHTML;
  }
})();
